<template>
    <div>
        <!-- <h5>Relationships</h5> -->
        <loader v-if="isLoading" />
        <b-table-simple
            v-else
            borderless
            hover
            class="list"
            id="table-relationships"
        >
            <b-thead>
                <b-tr>
                    <b-th>Name:</b-th>
                    <b-th>Type:</b-th>
                    <b-th>Address:</b-th>
                    <b-th>Email:</b-th>
                    <b-th>Home:</b-th>
                    <b-th>Work:</b-th>
                    <b-th>Mobile:</b-th>
                    <b-th></b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr
                    v-for="(relationship, i) in relationships"
                    :key="relationship.id"
                >
                    <b-td>
                        <input type="hidden" name="id" :value="i" />
                        <contact-name
                            v-if="isBusiness(relationship)"
                            :contact="relationship.business"
                            type="business"
                        ></contact-name>
                        <contact-name
                            v-else-if="isActorContact(relationship.actor)"
                            :contact="relationship.actor"
                            type="actor"
                        ></contact-name>
                        <client-name v-else :client="relationship.actor" />
                        <i
                            v-if="relationship.isprimary"
                            class="cus-award-star-gold-2"
                        ></i>
                    </b-td>
                    <b-td class="text-capitalize">
                        {{
                            relationship.relation_type
                                ? relationship.relation_type.type
                                : ""
                        }}
                    </b-td>
                    <b-td>
                        {{
                            isBusiness(relationship)
                                ? getAddress(relationship.business)
                                : getAddress(relationship.actor)
                        }}
                    </b-td>

                    <b-td>
                        {{
                            isBusiness(relationship)
                                ? relationship.business.email
                                : relationship.actor.email
                        }}
                    </b-td>
                    <b-td>
                        <b-link
                            class="text-nowrap"
                            v-if="!isBusiness(relationship)"
                            :href="'tel:' + relationship.actor.home"
                        >
                            {{ relationship.actor.home }}
                        </b-link>
                    </b-td>
                    <b-td>
                        <b-link
                            class="text-nowrap"
                            v-if="isBusiness(relationship)"
                            :href="'tel:' + relationship.business.phone"
                        >
                            {{ relationship.business.phone }}
                        </b-link>
                        <b-link
                            class="text-nowrap"
                            v-else
                            :href="'tel:' + relationship.actor.work"
                        >
                            {{ relationship.actor.work }}
                        </b-link>
                    </b-td>
                    <b-td>
                        <b-link
                            class="text-nowrap"
                            v-if="!isBusiness(relationship)"
                            :href="'tel:' + relationship.actor.mobile"
                        >
                            {{ relationship.actor.mobile }}
                        </b-link>
                    </b-td>
                    <b-td class="text-right">
                        <b-dropdown
                            v-if="_hasAccess('patient.client.remove')"
                            variant="link"
                            toggle-class="text-decoration-none"
                            no-caret
                            right
                            lazy
                        >
                            <template v-slot:button-content>
                                <i class="cus-cog-down"></i>
                            </template>

                            <b-dropdown-item
                                href="#"
                                v-if="
                                    !relationship.isprimary &&
                                    relationship.relation_type.id ==
                                        RELATIONS.PATIENT_ACTOR.OWNER
                                "
                                @click="assignPrimary(relationship)"
                            >
                                <i class="cus-award-star-gold-2"></i>
                                Assign as Primary
                            </b-dropdown-item>

                            <b-dropdown-item
                                href="#"
                                @click="edit(relationship)"
                            >
                                <i class="cus-page-white-edit"></i>
                                Edit Relationship
                            </b-dropdown-item>

                            <b-dropdown-item
                                href="#"
                                @click="confirmDelete(relationship)"
                            >
                                <i class="cus-delete"></i>
                                Delete Relationship
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-td>
                </b-tr>
                <b-tr v-if="relationships.length === 0">
                    <b-td colspan="8">
                        <i>No records available</i>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <b-pagination
            v-if="meta"
            v-show="meta.lastPage > 1"
            class="vet-pagination"
            align="right"
            v-model="meta.currentPage"
            :total-rows="meta.total"
            :per-page="meta.perPage"
            prev-text="Prev"
            next-text="Next"
            :hide-goto-end-buttons="true"
            @change="getList"
        />
        <modal-delete
            modal-id="confirm-delete-modal"
            ref="modalDelete"
            :patientId="patientId"
            @reload="getList()"
        />
        <modal-edit
            ref="modalEdit"
            @reload="getList()"
            :patientDetails="patientDetails"
        />
    </div>
</template>
<script>
import Loader from "@/components/elements/loader-list";
import ModalDelete from "@/components/patient-relationships/relationship-delete";
import ModalEdit from "@/components/patient-relationships/relationship-save";
import Relationships from "@/services/patient-relationships.js";
import RELATIONS from "@/constants/relations";
import { has, without } from "lodash";

export default {
    components: {
        Loader,
        ModalDelete,
        ModalEdit,
        ClientName: () => import("@/components/commons/client-name"),
        ContactName: () => import("@/components/commons/contact-name")
    },
    props: {
        patientId: {
            type: String
        },
        patientDetails: {
            type: Object
        }
    },
    data() {
        return {
            RELATIONS,
            relationships: [],
            isLoading: false,
            canRemove: false,
            selectedRelation: null,
            meta: null
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList(page) {
            this.isLoading = true;

            Relationships.getRelationships(this.patientId, {
                page: page ? page : 1
            })
                .then(response => {
                    if (response.message.code == 200) {
                        this.canRemove = response.permissions
                            ? response.permissions.client_patient_remove
                            : false;
                        this.relationships = response.resources;
                        this.meta = response.meta;
                        this.isLoading = false;
                        this.updatePatientProfile();
                    } else {
                        this.showError(
                            "Error : Unable to get relationship list"
                        );
                    }
                })
                .catch(error => {
                    this.showError("Error : Unable to get relationship list");
                    console.error(error);
                });
        },
        updatePatientProfile() {
            var encodedId = this.$route.params.id;

            if (encodedId) {
                this.$store
                    .dispatch("patient/getPatientDetails", {
                        id: encodedId,
                        encoded: this.$route.query.encoded === "0" ? 0 : 1
                    })
                    .then(details => {
                        this.$root.$emit("update-patient-details", details);
                    });
            }
        },
        showError(errorMessage) {
            this._message(errorMessage, "danger");
            this.isLoading = false;
        },
        confirmDelete(relation) {
            let type = this.isBusiness(relation) ? "business" : "actor";
            this.$refs.modalDelete.open(relation, type);
        },
        assignPrimary(relation) {
            this.isLoading = true;
            let params = {
                entity_id: relation.actor_id,
                entity_type: this.isBusiness(relation) ? "business" : "actor",
                relation_type: relation.relation_type.id
            };

            Relationships.setAsPrimaryRelationship(this.patientId, params)
                .then(response => {
                    if (response.message.code === 200) {
                        this._message(response.resource);
                        this.getList();
                    } else {
                        this.showError("Unable to set as primary");
                    }
                })
                .catch(error => {
                    this.showError("Unable to set as primary");
                    console.error(error);
                });
        },
        isBusiness(relationship) {
            return has(relationship, "business");
        },
        isActorContact(actor) {
            return _.find(actor.module, ["module_type", "contact"]);
        },
        getAddress(details) {
            let address = [
                details.address,
                details.city,
                details.state,
                details.zipcode
            ];

            address = without(address, undefined, null, "");

            return address.join(",");
        },
        edit(relation) {
            let type = this.isBusiness(relation) ? "business" : "actor";
            this.$refs.modalEdit.open(relation, type);
        }
    }
};
</script>
